import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { useBlueberrySizeBucketLabels } from '../../../dataMesh/blueberry/hooks/useBlueberrySizeBucketLabels';
import { BlueberrySizeChartLegend } from './components/BlueberrySizeChartLegend';
import { BlueberrySizeChartRow } from './components/BlueberrySizeChartRow';
import { ErrorOverlay } from './components/ErrorOverlay';
import { LoadingOverlay } from './components/LoadingOverlay';
import { MeasurableBerriesInfoLabel } from './components/MeasurableBerriesInfoLabel';
import { useBlueberrySizeChartData } from './hooks/useBlueberrySizeChartData';
import { getBucketTotal } from './utils/getBucketTotal';

export const BlueberrySizeChart = () => {
  const { isLoading, error, dataset, totalCount } = useBlueberrySizeChartData();

  const labelMap = useBlueberrySizeBucketLabels();

  const { largestBucketCount, totalMeasured } = useMemo(() => {
    let largestBucketCount = 0;
    let totalMeasured = 0;

    dataset.forEach((data) => {
      const sum = getBucketTotal(data);
      totalMeasured = totalMeasured + sum;
      if (sum > largestBucketCount) {
        largestBucketCount = sum;
      }
    });
    return { largestBucketCount, totalMeasured };
  }, [dataset]);

  if (isLoading) {
    return <LoadingOverlay />;
  }
  if (error || !totalCount) {
    return <ErrorOverlay />;
  }

  return (
    <Stack padding={'1rem 1.5rem'} justifyContent={'space-around'}>
      <Stack height={'100%'} justifyContent={'space-evenly'}>
        {dataset.map((data) => {
          return (
            <BlueberrySizeChartRow
              data={data}
              label={labelMap?.[data.size] || data.size}
              fullBarValue={largestBucketCount}
              totalMeasured={totalMeasured}
            />
          );
        })}
      </Stack>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <BlueberrySizeChartLegend />
        <MeasurableBerriesInfoLabel
          measurableBerries={totalMeasured}
          totalBerries={totalCount}
        />
      </Stack>
    </Stack>
  );
};
